import ProgramDialogManager from "./ProgramDialogManager.tsx";
export default ProgramDialogManager;
